import { DescriptionOutlined } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import TabContainer from '../../components/tab-container';

const PrivacyTab = forwardRef((props, ref) => {
    return (
        <TabContainer title={_('Políticas de privacidad')}>
            <Stack spacing={2}>
                <Typography variant='body1' color='primary'>
                    {_(
                        'Ponemos a tu disposición el documento completo de la Política de Privacidad de {{appName}}, donde se detallan los lineamientos sobre el uso y resguardo de la información.',
                        {
                            appName: settings.app.name,
                        }
                    )}
                </Typography>
                <Button
                    variant='contained'
                    color='primary'
                    endIcon={<DescriptionOutlined />}
                    sx={{
                        width: 'fit-content',
                    }}
                    onClick={() => {
                        if (settings.app.privacyPolicy) {
                            window.open(settings.app.privacyPolicy, '_blank');
                        }
                    }}
                >
                    {_('Ver documento')}
                </Button>
            </Stack>
        </TabContainer>
    );
});

export default PrivacyTab;
